/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Interact_PhysicalInputs */

const en_onboarding_interact_physical = /** @type {(inputs: Onboarding_Interact_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical books & papers`)
};

const es_onboarding_interact_physical = /** @type {(inputs: Onboarding_Interact_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros y artículos físicos`)
};

/**
* | output |
* | --- |
* | "Physical books & papers" |
*
* @param {Onboarding_Interact_PhysicalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_interact_physical = /** @type {((inputs?: Onboarding_Interact_PhysicalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Interact_PhysicalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_interact_physical(inputs)
	return en_onboarding_interact_physical(inputs)
});